import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import { EnvService } from '../../configuration/env.service';
import { WebSocketService } from '../../server-communication/services/websocket.service';
import LocationContextActions from './location-context.action-types';

@Injectable()
export class LocationContextEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly webSocketService: WebSocketService,
        private readonly env: EnvService
    ) {}

    // Terminals
    requestTerminals$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LocationContextActions.requestTerminals),
                tap(() =>
                    this.webSocketService.sendMessage(WebSocketMessageType.Terminals, {
                        stationId: this.env.config.stationId
                    })
                )
            ),
        { dispatch: false }
    );

    // CenterlineGroups
    requestCenterlineGroups$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LocationContextActions.requestCenterlineGroups),
                map(action => action.selectedTerminal),
                tap(selectedTerminal =>
                    this.webSocketService.sendMessage(WebSocketMessageType.CenterlineGroups, {
                        selectedTerminal
                    })
                )
            ),
        { dispatch: false }
    );

    // Centerlines
    requestCenterlines$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LocationContextActions.requestCenterlines),
                tap(() => this.webSocketService.sendMessage(WebSocketMessageType.Centerlines, {}))
            ),
        { dispatch: false }
    );
}
